import React, { useState } from "react";
import useAuth from "../../hooks/auth/useAuth";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import { FiEye, FiEyeOff, FiShield, FiCheckCircle } from "react-icons/fi";
import "../../assets/css/setting.css";

const SECURITY_TIPS = [
  "Au moins 8 caractères, avec majuscules, chiffres et symboles.",
  "Évitez de réutiliser un mot de passe déjà utilisé ailleurs.",
  "Ne partagez jamais votre mot de passe, même avec un collègue.",
];

function Setting() {
  const [passwordCurrent, setPasswordCurrent] = useState("");
  const [password, setPassword] = useState("");
  const [passwordConfirm, setPasswordConfirm] = useState("");

  const [showCurrent, setShowCurrent] = useState(false);
  const [showNew, setShowNew] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  const [formError, setFormError] = useState("");

  const { message, error, updatePassword } = useAuth();

  const handlePasswordChange = async (e) => {
    e.preventDefault();
    setFormError("");

    if (!passwordCurrent || !password || !passwordConfirm) {
      setFormError("Tous les champs sont obligatoires.");
      return;
    }

    if (password !== passwordConfirm) {
      setFormError("Les nouveaux mots de passe ne correspondent pas.");
      return;
    }

    confirmAlert({
      title: "Confirmation",
      message: "Êtes-vous sûr de vouloir changer votre mot de passe ?",
      buttons: [
        {
          label: "Oui",
          onClick: async () => {
            const userData = localStorage.getItem("user");
            if (!userData) {
              setFormError("Utilisateur non authentifié.");
              return;
            }

            const parsedUserData = JSON.parse(userData);
            if (!parsedUserData?._id) {
              setFormError("ID utilisateur introuvable.");
              return;
            }

            await updatePassword(parsedUserData._id, {
              passwordCurrent,
              password,
              passwordConfirm,
            });

            setPasswordCurrent("");
            setPassword("");
            setPasswordConfirm("");
          },
        },
        {
          label: "Non",
          onClick: () => {},
        },
      ],
    });
  };

  return (
    <div className="container-fluid">
      {/* TITLE */}
      <div className="d-flex align-items-center justify-content-between mb-4">
        <h2 className="h4 mb-0">Paramètres</h2>
      </div>

      <div className="row g-4">
        {/* ---- FORMULAIRE ---- */}
        <div className="col-lg-7">
          <div className="card shadow-sm">
            <div className="card-header bg-white">
              <h3 className="h6 mb-0">Modifier le mot de passe</h3>
            </div>

            <div className="card-body">
              <form onSubmit={handlePasswordChange} noValidate>
                <div className="mb-3">
                  <label className="form-label">Ancien mot de passe</label>
                  <div className="setting-input-wrap">
                    <input
                      type={showCurrent ? "text" : "password"}
                      className="form-control"
                      value={passwordCurrent}
                      onChange={(e) => setPasswordCurrent(e.target.value)}
                      required
                    />
                    <button
                      type="button"
                      className="setting-eye"
                      onClick={() => setShowCurrent((v) => !v)}
                      aria-label={
                        showCurrent
                          ? "Masquer le mot de passe"
                          : "Afficher le mot de passe"
                      }
                    >
                      {showCurrent ? <FiEyeOff /> : <FiEye />}
                    </button>
                  </div>
                </div>

                <div className="mb-3">
                  <label className="form-label">Nouveau mot de passe</label>
                  <div className="setting-input-wrap">
                    <input
                      type={showNew ? "text" : "password"}
                      className="form-control"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      required
                    />
                    <button
                      type="button"
                      className="setting-eye"
                      onClick={() => setShowNew((v) => !v)}
                      aria-label={
                        showNew
                          ? "Masquer le mot de passe"
                          : "Afficher le mot de passe"
                      }
                    >
                      {showNew ? <FiEyeOff /> : <FiEye />}
                    </button>
                  </div>
                </div>

                <div className="mb-3">
                  <label className="form-label">
                    Confirmer le nouveau mot de passe
                  </label>
                  <div className="setting-input-wrap">
                    <input
                      type={showConfirm ? "text" : "password"}
                      className="form-control"
                      value={passwordConfirm}
                      onChange={(e) => setPasswordConfirm(e.target.value)}
                      required
                    />
                    <button
                      type="button"
                      className="setting-eye"
                      onClick={() => setShowConfirm((v) => !v)}
                      aria-label={
                        showConfirm
                          ? "Masquer le mot de passe"
                          : "Afficher le mot de passe"
                      }
                    >
                      {showConfirm ? <FiEyeOff /> : <FiEye />}
                    </button>
                  </div>
                </div>

                {formError && (
                  <div className="alert alert-danger">{formError}</div>
                )}
                {error && <div className="alert alert-danger">{error}</div>}
                {message && (
                  <div className="alert alert-success">{message}</div>
                )}

                <div className="d-flex justify-content-end mt-4">
                  <button type="submit" className="btn btn-primary px-4">
                    Changer le mot de passe
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>

        {/* ---- CONSEILS SÉCURITÉ ---- */}
        <div className="col-lg-5">
          <div className="card shadow-sm h-100">
            <div className="card-body">
              <div className="d-flex align-items-center gap-2 mb-3">
                <span className="setting-shield">
                  <FiShield />
                </span>
                <h3 className="h6 mb-0">Bonnes pratiques</h3>
              </div>

              <ul className="list-unstyled d-flex flex-column gap-3 mb-0">
                {SECURITY_TIPS.map((tip, i) => (
                  <li key={i} className="d-flex align-items-start gap-2">
                    <FiCheckCircle className="text-success flex-shrink-0 mt-1" />
                    <span className="text-secondary small">{tip}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Setting;
